module.exports = "pegasus/assets/f-icon3.png";